// NOTE: Copied from workbench-icons based on guidance from design-systems
// because there was a problem with server side rendering and using these icons.
const Chat = () => (
  <svg viewBox="0 0 16 16" width="1em" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 2h-7A2.5 2.5 0 002 4.5v4.256c0 1.121.909 2.03 2.03 2.03.95 0 1.72.77 1.72 1.72v1.018l2.399-2.262a1.75 1.75 0 011.2-.476H11.5a2.5 2.5 0 002.5-2.5V4.5A2.5 2.5 0 0011.5 2zM4.5.5a4 4 0 00-4 4v4.256a3.53 3.53 0 003.53 3.53.22.22 0 01.22.22v2.177c0 .877 1.048 1.329 1.686.727l3.242-3.056a.25.25 0 01.171-.068H11.5a4 4 0 004-4V4.5a4 4 0 00-4-4h-7z"
    />
  </svg>
);

export default Chat;
